import Application from "./application/Application"
import {TweenMax} from "gsap"
import * as PIXI from "pixi.js"
import Facade from "./Facade"
import TickerGenerator from "./generator/TickerGenerator"
import {IntegrationManager} from "@/Imports";
import Utils from "@base/utils/Utils";

TickerGenerator

if (!Facade.isDebug) {
  console.log = function () {
  }
}

window.PIXI = PIXI
require("pixi-spine")

TweenMax.ticker.useRAF(true)

console.log("::: 2.0.2.4");

console.yellow = (value) => console.log(`%c${value}`, 'color: yellow')
console.blue = (value) => console.log(`%c${value}`, 'color: blue')
console.green = (value) => console.log(`%c${value}`, 'color: green')
console.red = (value) => console.log(`%c${value}`, 'color: red')



function loadThreePI_CDN() {
  if (Utils.getUrlParam('customer', null) === "onextwo") {
    const src = process.env.NODE_ENV !== 'production' ? "https://cdn-stage.1x2networkhub.com/f1x2games/infrastr_generic-framework/clientAPI.game.min.js" :
        "https://www.1x2gamingcdn.com/f1x2games/infrastr_generic-framework/clientAPI.game.min.js" // live

    return new Promise((resolve, reject) => {
      console.log(`::: start loading CDN: ${src}`)
      const element = document.createElement('script')
      document.head.appendChild(element)

      element.src = src
      element.onload = () => {
        console.log('::: complete loading ThreePI CDN. Resolve promise:', element)
        resolve()
      }
      element.onerror = (event) => {
        console.error('::: failed to loading ThreePI CDN. Failed event:', element)
        reject()
      }
    })
  }

  if (Utils.getUrlParam('customer', null) === "gan" && !isMobileDevice()) {
    console.log("::: GAN LOADING")
    const src = process.env.NODE_ENV === 'production' ? "https://itapi.gameaccount.com/js/ganSlipstream.js" :
        "https://itapi.qa.gameaccount.com/js/ganSlipstream.js"

    return new Promise((resolve, reject) => {
      console.log(`::: start loading  GAN CDN: ${src}`)
      const element = document.createElement('script')
      document.head.appendChild(element)

      element.src = src
      element.onload = () => {
        console.log('::: complete loading ThreePI CDN. Resolve promise:', element)
        resolve()
      }
      element.onerror = (event) => {
        console.error('::: failed to loading ThreePI CDN. Failed event:', element)
        reject()
      }
    })
  }

  return new Promise((resolve, reject) => {
    resolve();
  });
}


function isMobileDevice() {
  if (window.matchMedia('(hover: none)').matches) {
    // according to UI module implementation
    return true
  }

  return navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) != null
}

loadThreePI_CDN()
  .then(() => {
    new IntegrationManager()
    new Application()
  })
  .catch(() => {
    new Application()
  })
